/**
 * Pre-compiled localized messages for FieldErrors component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import fieldErrorsMessages_en from "./intl/en";
import fieldErrorsMessages_de from "./intl/de";
import fieldErrorsMessages_es from "./intl/es";
import fieldErrorsMessages_fr from "./intl/fr-FR";
import fieldErrorsMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const fieldErrorsMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(fieldErrorsMessages_en),
  de: normalizeMessages(fieldErrorsMessages_de),
  es: normalizeMessages(fieldErrorsMessages_es),
  "fr-FR": normalizeMessages(fieldErrorsMessages_fr),
  "pt-BR": normalizeMessages(fieldErrorsMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for FieldErrors component
 */
export type FieldErrorsMessageKey =
  | "duplicateValue"
  | "emptyValue"
  | "invalidFormat"
  | "invalidFractionalNumber"
  | "invalidFromServer"
  | "invalidNegativeNumber"
  | "invalidValue"
  | "missingRequiredField"
  | "resourceNotFound"
  | "valueAboveMaximum"
  | "valueBelowMinimum"
  | "valueBlocked"
  | "valueOutOfRange"
  | "valueTooLong"
  | "valueTooShort";
